var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tabTemplates && _vm.tabTemplates.length > 1
    ? _c(
        "TabsContainer",
        _vm._g(
          {
            key: _vm.tabTemplates.length,
            ref: "tabsContainer",
            attrs: {
              tabNames: _vm.renderTabNames,
              getCurrentTab: _vm._getCurrentTab,
            },
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.tabTemplates, function (tab, index) {
                  return {
                    key: "icon-" + index,
                    fn: function () {
                      return [_vm._t("icon-" + index)]
                    },
                    proxy: true,
                  }
                }),
              ],
              null,
              true
            ),
          },
          _vm.$listeners
        ),
        [
          _vm._v(" "),
          _vm._l(_vm.tabTemplates, function (tab, index) {
            return [
              _c(
                "div",
                {
                  key: tab.tabName,
                  attrs: { slot: "tab-" + index },
                  slot: "tab-" + index,
                },
                [
                  _c(
                    "keep-alive",
                    [
                      _vm.showCondition(tab.showCondition)
                        ? _c(
                            index === _vm.currentTabIndex ||
                              index === _vm.privateCurTabIndex
                              ? tab.component
                              : _vm.ComponentNoop,
                            _vm._b(
                              {
                                ref: tab.ref || "",
                                refInFor: true,
                                tag: "component",
                              },
                              "component",
                              Object.assign({}, tab.params),
                              false
                            )
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          }),
        ],
        2
      )
    : _vm.tabTemplates && _vm.tabTemplates.length === 1
    ? _c(_vm.tabTemplates[0].component, { tag: "component" })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }